export default __webpack_public_path__ + "static/media/insurance_workers.3dce4a36.jpg";